import React from 'react'

export const Sources: React.FC = () => {
  const sources = [
    {
      title: "Consumer Financial Protection Bureau - Timeshare Complaints",
      description: "Official CFPB data showing thousands of timeshare-related complaints and enforcement actions.",
      url: "https://www.consumerfinance.gov/",
      type: "Government"
    },
    {
      title: "Federal Trade Commission - Timeshare Resales",
      description: "FTC warnings about timeshare resale scams and consumer protection guidelines.",
      url: "https://www.ftc.gov/",
      type: "Government"
    },
    {
      title: "American Resort Development Association (ARDA) Statistics",
      description: "Industry data on timeshare ownership, costs, and legal proceedings.",
      url: "https://www.arda.org/",
      type: "Industry"
    },
    {
      title: "State Attorney General Consumer Protection Reports",
      description: "Multi-state investigations into timeshare sales practices and exit company scams.",
      url: "#",
      type: "Legal"
    },
    {
      title: "Consumer Reports - Timeshare Investigation",
      description: "Independent analysis of timeshare industry practices and consumer experiences.",
      url: "https://www.consumerreports.org/",
      type: "Independent"
    },
    {
      title: "University Law Review Articles",
      description: "Academic research on timeshare law, consumer protection, and industry regulation.",
      url: "#",
      type: "Academic"
    }
  ]

  return (
    <section className="bg-gray-50 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-4">
            Research & <span className="text-blue-600">Legal Sources</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our strategies are based on extensive research of consumer protection laws, 
            government investigations, and documented legal precedents. Here are our key sources.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {sources.map((source, index) => (
            <div key={index} className="bg-white rounded-lg shadow-md p-6 border border-gray-200 hover:shadow-lg transition-shadow">
              <div className="flex items-center justify-between mb-3">
                <span className={`px-2 py-1 text-xs font-semibold rounded-full ${
                  source.type === 'Government' ? 'bg-green-100 text-green-800' :
                  source.type === 'Legal' ? 'bg-green-100 text-green-800' :
                  source.type === 'Industry' ? 'bg-green-100 text-green-800' :
                  source.type === 'Academic' ? 'bg-green-100 text-green-800' :
                  'bg-green-100 text-green-800'
                }`}>
                  {source.type}
                </span>
                <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
              </div>
              
              <h3 className="font-semibold text-gray-900 mb-2 text-sm">
                {source.title}
              </h3>
              
              <p className="text-gray-600 text-xs mb-4">
                {source.description}
              </p>
              
              {source.url !== '#' && (
                <a 
                  href={source.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:text-blue-800 text-xs font-medium"
                >
                  View Source →
                </a>
              )}
            </div>
          ))}
        </div>

        {/* Legal Disclaimer */}
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
          <h3 className="text-lg font-semibold text-blue-900 mb-3">
            Legal Research Foundation
          </h3>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-sm text-blue-800">
            <div>
              <h4 className="font-medium mb-2">Consumer Protection Laws</h4>
              <ul className="space-y-1 text-xs">
                <li>• Truth in Lending Act (TILA)</li>
                <li>• Fair Credit Reporting Act (FCRA)</li>
                <li>• Fair Debt Collection Practices Act</li>
                <li>• State Unfair Business Practice Laws</li>
                <li>• Cooling-off Period Regulations</li>
              </ul>
            </div>
            
            <div>
              <h4 className="font-medium mb-2">Legal Precedents</h4>
              <ul className="space-y-1 text-xs">
                <li>• Contract rescission case law</li>
                <li>• Unconscionability doctrines</li>
                <li>• Misrepresentation claims</li>
                <li>• UDAP violation precedents</li>
                <li>• Class action settlements</li>
              </ul>
            </div>
          </div>
          
          <div className="mt-4 pt-4 border-t border-blue-200">
            <p className="text-blue-700 text-xs leading-relaxed">
              <strong>Disclaimer:</strong> This information is for educational purposes only and does not constitute legal advice. 
              While our strategies are based on established legal principles and documented consumer rights, 
              individual results may vary based on specific circumstances, state laws, and timeshare company policies.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}